export default function ApplicationTitle({ transparent = true, className = "", ...props }) {
    const imageSrc = transparent 
        ? "/images/tituloTransparente.png" 
        : "/images/tituloFondoBlanco.png";
    
    return (
        <img
            {...props}
            className={`h-auto w-auto ${className}`}
            src={imageSrc}
            alt="ValidaTest - Plataforma de Testing"
            style={{ maxHeight: '120px', width: 'auto', ...props.style }}
        />
    );
}
